import { SurveySettings } from '../../types';
import { apiError } from '../../utils/errors';

export const getSettingsByUrlSlug = async (urlSlug: string, metadataToken?: string): Promise<SurveySettings> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/settings/${urlSlug}${metadataToken ? `?m=${metadataToken}` : ''}`);
  const responseJson = await response.json();

  if (!response.ok) {
    throw apiError(response.status, responseJson?.message || 'Failed to fetch application');
  }

  const settings = responseJson.data;
  return settings;
};
